import { useCallback, useEffect, useState } from "react";
import pubsub from "sweet-pubsub";
import { getStoredAuthToken } from "../utils/authToken";

export const useAuthStatus = () => {
    const [isSignedIn, setIsSignedIn] = useState(!!getStoredAuthToken());

    const signOut = useCallback(() => setIsSignedIn(false), []);

    useEffect(() => {
        const performSignOut = () => signOut();
        pubsub.on("logout", () => signOut());

        return () => {
            pubsub.off("logout", performSignOut);
        };
    }, [signOut]);

    return { isSignedIn, setIsSignedIn };
};
